export default __webpack_public_path__ + "static/media/coyote.18e38226.jpg";